import { hasAccess } from 'utils/access'
import { getRequestStatistics } from './RequestsService'
import { getDriverCabinet, getMyDocChangeRequests } from './DriverRegistrationService'

export const emptyRequestCounts = () => ({ bases: null, registrations: null, documents: null, mine: null, total: null })

export async function getPendingRequestCounts(user) {
  if (user.is_report_only || user.erp_role === 'reporter') return emptyRequestCounts()
  const administrative = hasAccess(user, 'requests') || hasAccess(user, 'confirmations')
  const types = administrative ? ['bases', 'registrations', 'documents']
    : ['operator', 'base_operator'].includes(user.erp_role) ? ['bases'] : []
  const counts = { bases: 0, registrations: 0, documents: 0, mine: 0, total: 0 }
  if (types.length) {
    await Promise.all(types.map(async type => {
      const { data } = await getRequestStatistics({ type })
      if (!Number.isInteger(data.pending) || data.pending < 0) throw new Error('Invalid request count')
      counts[type] = data.pending
    }))
    counts.total = types.reduce((total, type) => total + counts[type], 0)
  }
  if (user.erp_role === 'driver') {
    const { data: cabinet } = await getDriverCabinet()
    const { data: documents } = cabinet.driver ? await getMyDocChangeRequests() : { data: [] }
    const rows = documents.results || documents
    if (!Array.isArray(rows)) throw new Error('Invalid personal requests')
    counts.mine = Number(!!cabinet.pending_base_request)
      + Number(cabinet.driver_checked?.status === 'pending')
      + rows.filter(item => item.status === 'pending').length
    if (!administrative) counts.total = counts.mine
  }
  return counts
}
